var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgR(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 11.5,
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4703 17.3906C29.0879 17.3906 29.7054 17.5836 30.3229 17.9695C30.9661 18.3555 31.3006 18.8058 31.3263 19.3204C31.3263 19.7063 31.1462 20.118 30.786 20.5554C30.4258 20.9928 30.027 21.2115 29.5896 21.2115C29.3066 21.2115 29.0621 21.1729 28.8563 21.0957C28.6762 20.9928 28.4575 20.8513 28.2002 20.6712C27.8142 20.3881 27.5055 20.2466 27.2739 20.2466C26.7336 20.2466 26.219 20.9285 25.7301 22.2921C25.267 23.6301 24.8939 25.2639 24.6109 27.1937C24.3279 29.0977 24.1735 30.7958 24.1477 32.2881C24.1477 32.7513 23.5302 32.9828 22.2952 32.9828C21.4719 32.9828 21.0344 32.8928 20.983 32.7127C20.983 32.6098 20.9959 32.2624 21.0216 31.6706C21.0473 31.0788 21.0602 30.4613 21.0602 29.8181L21.1374 21.7132C21.1374 20.0408 20.7514 19.2046 19.9795 19.2046C19.3363 19.2046 18.5901 19.6934 17.741 20.6712C17.6896 20.7226 17.651 20.7484 17.6253 20.7484C17.5223 20.7484 17.4451 20.7098 17.3937 20.6326C17.3165 20.5297 17.3036 20.4396 17.3551 20.3624C18.796 18.407 20.2754 17.4292 21.7935 17.4292C22.6426 17.4292 23.2472 17.738 23.6074 18.3555C23.9934 18.9473 24.1992 19.9507 24.2249 21.3659L24.1863 25.7271C24.5466 23.2313 25.074 21.2244 25.7687 19.7063C26.4891 18.1625 27.3897 17.3906 28.4703 17.3906Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5055_25414",
    x1: 49.1429,
    y1: 52.6071,
    x2: 16.3715,
    y2: -10.6055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#923DFF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F62D5D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgR);
export default __webpack_public_path__ + "static/media/r.0cbdb754a460fc5ce1d673d4839ccf70.svg";
export { ForwardRef as ReactComponent };